import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';

export interface PasswordResetRequestBody {
  email: string;
  court_id: number;
}

export interface PasswordResetConfirmBody {
  password: string;
  confirm_password: string;
}

export interface PasswordRecoveryTokenResponse {
  court: {
    id: number;
    name: string;
    state_geoname_code: string;
    clerk: {
      name: string;
      photo: string | null;
    };
    residence_considerations: string | null;
    images: {
      file: string;
      name: string;
    }[];
  };
  email: string;
}

@Injectable({ providedIn: 'root' })
export class PasswordResetHttpService {
  private readonly _http = inject(HttpClient);
  private readonly _apiUrl = environment.api;

  public forgotPassword(params: { email: string; court_id: number }) {
    const body: PasswordResetRequestBody = params;
    return this._http.post<void>(`${this._apiUrl}/auth/forgot-password/`, body);
  }

  public validateRecoveryToken(token: string) {
    return this._http.get<PasswordRecoveryTokenResponse>(
      `${this._apiUrl}/auth/password-recovery/${token}`,
    );
  }

  public recoverPassword(params: {
    token: string;
    body: PasswordResetConfirmBody;
  }) {
    return this._http.post<void>(
      `${this._apiUrl}/auth/password-recovery/${params.token}/`,
      params.body,
    );
  }
}
